
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_story/[...slug]",
      function () {
        return require("private-next-pages/_story/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_story/[...slug]"])
      });
    }
  